import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./redux/auth";
import messageReducer from "./redux/message";
import globalReducer from "./redux/global";
import { api } from "./services/measurement.service"
import { adminApi } from "./services/admin.service";
import { miApi } from "./services/mi.result.service";
import { teleconApi } from "./services/telecon.service";
import { siteContentApi } from "./services/siteContent.service";
import { reviewApi } from "./services/review.service";
import { residentApi } from "./services/resident.service";
import { cookbookApi } from "./services/cookbook.service";

const reducer = {
    auth: authReducer,
    message: messageReducer,
    global: globalReducer,
    [api.reducerPath]: api.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [teleconApi.reducerPath]: teleconApi.reducer,
    [miApi.reducerPath]: miApi.reducer,
    [siteContentApi.reducerPath]: siteContentApi.reducer,
    [reviewApi.reducerPath]: reviewApi.reducer,
    [residentApi.reducerPath]: residentApi.reducer,
    [cookbookApi.reducerPath]: cookbookApi.reducer,
}

const store = configureStore({
    reducer: reducer,
    middleware: (getDefault) => getDefault().concat(api.middleware).concat(adminApi.middleware).concat(miApi.middleware).concat(teleconApi.middleware).concat(siteContentApi.middleware).concat(reviewApi.middleware).concat(residentApi.middleware).concat(cookbookApi.middleware),
    devTools: true,
})

export default store;
